import React from "react";
import FilterRow from "./FilterRow";
import {FaLink, FaEyeSlash, FaRobot, FaCode} from "react-icons/fa";

export const IndexabilityFilters = ({handleSwitchToggle, state}) => {
    const t = state.toggles;
    return (
        <FilterRow
            label="Indexability"
            items={[
                {label: "Canonicalized", icon: FaLink, color: "#6f42c1", checked: t.reasonCanonicalizedChecked, onChange: handleSwitchToggle("reasonCanonicalizedChecked"), key: "canonicalized"},
                {label: "Meta noindex", icon: FaEyeSlash, color: "#6c757d", checked: t.reasonMetaNoindexChecked, onChange: handleSwitchToggle("reasonMetaNoindexChecked"), key: "meta-noindex"},
                {label: "robots.txt", icon: FaRobot, color: "#495057", checked: t.reasonRobotsTxtChecked, onChange: handleSwitchToggle("reasonRobotsTxtChecked"), key: "robots-txt"},
                {label: "X-Robots noindex", icon: FaCode, color: "#6c757d", checked: t.reasonXRobotsNoindexChecked, onChange: handleSwitchToggle("reasonXRobotsNoindexChecked"), key: "x-robots-noindex"}
            ]}
        />
    );
};
